module.exports = __webpack_public_path__ + "img/pdf.0e23612f.svg";